module.exports = __webpack_public_path__ + "static/media/icon_sns_link_color.cfc2d8fd.svg";